import {
  classNames,
  FlexCenter,
  Media,
  SkeletonLine,
  TextLabel,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { BestOfferButton } from "./BestOfferButton"

type Props = {
  className?: string
}

export const CreateCollectionOfferFlowHeaderActions = ({
  className,
}: Props) => {
  const t = useTranslations("wallet.CreateCollectionOfferFlowHeaderActions")
  return (
    <FlexCenter className={classNames("gap-3 md:mr-10 xl:mr-0", className)}>
      <Media greaterThanOrEqual="md">
        <TextLabel className="whitespace-nowrap" size="2xs">
          {t("setPriceTo")}
        </TextLabel>
      </Media>
      <BestOfferButton className="w-full" />
    </FlexCenter>
  )
}

export const CreateCollectionOfferFlowHeaderActionsSkeleton = ({
  className,
}: {
  className?: string
}) => {
  const t = useTranslations("wallet.CreateCollectionOfferFlowHeaderActions")
  return (
    <FlexCenter className={classNames("gap-3 md:mr-10 xl:mr-0", className)}>
      <Media greaterThanOrEqual="md">
        <TextLabel className="whitespace-nowrap" size="2xs">
          {t("setPriceTo")}
        </TextLabel>
      </Media>
      <SkeletonLine className="h-8 w-full md:w-[68px]" />
    </FlexCenter>
  )
}
